import { useMutation } from '@tanstack/react-query';
import { vaultApi } from '@modules/vault/api';

export const useCreateVaultStorage = (opportunityId: string) => {
  const { mutateAsync, error, isPending } = useMutation({
    mutationKey: ['create-vault-storage', opportunityId],
    mutationFn: () => vaultApi.createVaultStorage(opportunityId),
  });

  return { error, mutateAsync, isPending };
};
